// routes.js
const routes = {
    // Routes principales
    home: "/",
    accueil: "/accueil",
    login: "/login",

    profil: "/profil",
    profilConfirmation: '/profil/confirmation',
    profilConfirmationToken: "/profil/confirmation/:token/:mail",
    profilEnrolement: "/profil/enrolement/:token/:uid",
    userStatus: "/userstatus",
    passwordReset: "/password-reset",

    salarieCrmHistory: "/salaries/crm_history",

    report: "/report",
    reports: "/reports",
    reportsMe: "/reports/me",

    // Routes de seances
    seances: "/seances",
    seancesAll: "/seances/all",
    seance: "/seances/seance/:id",
    seancesByDate: "/seances/date/:jour",
    seancesReferent: "/seances/referent",
    seancesCoach: "/seances/coach",
    seancesCoachDisponibles: "/seances/coach/disponibles",
    seancesCoachEnregistrees: "/seances/coach/enregistrees",
    seancesCoachEffectuees: "/seances/coach/effectuees?sort=dateDesc",
    seancesEnregistrees: "/seances/enregistrees",
    seancesDisponibles: "/seances/disponibles",
    seancesEffectuees: "/seances/effectuees",

    // Routes de planning
    planning: "/planning",

    // Routes d'activités
    activites: "/activites",
    activite: "/activites/activite/:id",

    // Stats
    stats: "/stats",
    statsMain: "/stats/main",
    statsMois: "/stats/mois",
    statsSeances: "/stats/seances",
    statsActiviteTypes: "/stats/activite_types",
    statsUsers: "/stats/users",

    mentionsLegales: "/mentions-legales",
    politiqueDeConfidentialite: "/politique-de-confidentialite",
    reglementInterieur: "/reglement-interieur",
    cgv: "/cgv",
    cgu: "/cgu",

    salaries: "/salaries",
    salariesCrmHistory: '/salaries/crm_history',
    salariesImport: "/salaries/import",

    // Pages d'erreur
    unauthorized: "/unauthorized",
    notFound: "*",  // 404



    // Routes administrateur
    admin: "/admin",
    adminDashboard: "/admin",

    adminEntreprises: "/admin/entreprises",
    adminEntreprise: "/admin/entreprises/:entrepriseId",
    adminEntrepriseSalaries: "/admin/entreprises/:entrepriseId/salaries",
    adminContrats: "/admin/entreprises/:entrepriseId/contrats",
    adminContrat: "/admin/entreprises/:entrepriseId/contrats/:contratId",
    adminActivites: "/admin/entreprises/:entrepriseId/contrats/:contratId/activites",
    adminActivite: "/admin/entreprises/:entrepriseId/contrats/:contratId/activites/:activiteId",
    adminActiviteTypes: "/admin/activites/types",
    adminActiviteTypesCreation: "/admin/activites/types?mode=creation",
    adminActiviteType: "/admin/activites/types/:activiteTypeId",
    adminSeancesDirect: "/admin/seances",
    adminSeanceDirect: "/admin/seances/:seanceId",
    adminSeances:                "/admin/entreprises/:entrepriseId/contrats/:contratId/activites/:activiteId/seances",
    adminSeance:                "/admin/entreprises/:entrepriseId/contrats/:contratId/activites/:activiteId/seances/:seanceId",
    adminSeanceParticipations:  "/admin/entreprises/:entrepriseId/contrats/:contratId/activites/:activiteId/seances/:seanceId/participations",
    adminSeanceParticipation:  "/admin/entreprises/:entrepriseId/contrats/:contratId/activites/:activiteId/seances/:seanceId/participations/:participationId",

    adminJustificatifsTypes: "/admin/justificatifs/types",
    adminJustificatifsType: "/admin/justificatifs/types/:typeId",

    adminUtilisateurs: "/admin/utilisateurs",
    adminUtilisateur: "/admin/utilisateurs/:utilisateurId",
    adminUtilisateurStats: "/admin/utilisateurs/:utilisateurId/stats",
    adminCrm: "/admin/crm",
    adminCrmHistory: "/admin/crm/user_history",
    adminRoles: "/admin/roles",
    adminRole: "/admin/roles/:roleName",

    adminAbsences: "/admin/absences",

    adminCreation: "?mode=creation",
    adminCreationEnMasseCsv: "?mode=creation_en_masse_csv",
};

const routesApi = {
    login_check: "/login_check",
    tokenRefresh: "/token/refresh",
    passwordReset: "/password_reset",
    passwordNew: "/password_new/:token/:mail",
    user: "/user",

    seancesPlanning: "/seances/planning?start=:start&end=:end",

    adminEntrepriseSendInviteCreateAccountMassive: "/admin/entreprises/:entrepriseId/send_invite_create_account_massive",
    adminEntrepriseSendInviteCreateAccountUnit: "/admin/entreprises/:entrepriseId/send_invite_create_account_unit",
    adminEntrepriseEnrolement: "/admin/entreprises/:entrepriseId/enrolement",

    adminUtilisateursSetStatus: "/admin/utilisateurs/:utilisateurId/status",
};

const externes = {
    facebook: "https://www.facebook.com/elancia.france",
    instagram: "https://www.instagram.com/elancia.officiel/",
    youtube: "https://www.youtube.com/c/ElanciaFrance/videos",
    linkedin: "https://www.linkedin.com/showcase/elancia-at-work/",
}

/**
 * Generate a URL from a route name and parameters
 * @param route - route name to generate, example: adminUtilisateurShow
 * @param params - parameters to replace in the URL, example: {key: value} => /route
 * @param queryParams {object} - query parameters to add to the URL, example: {key: value} => ?key=value
 * @returns {*}
 */
const generate = ({route, params = {}, queryParams = {}}) => {
    // Vérifier si la route contient des paramètres et si oui qu'ils sont bien fournis
    const routeParams = route.match(/:(\w+)/g);
    if (routeParams) {
        routeParams.forEach(param => {
            const key = param.replace(":", "");
            if (!params[key]) {
                console.error(`Missing parameter for route ${route}: ${key}`);
                return null;
            }
        });
    }

    let url = route.replace(/:(\w+)/g, (_, key) => params[key]);

    const queryString = new URLSearchParams(queryParams).toString();
    if (queryString) {
        url += `?${queryString}`;
    }

    return url;
};


export default {
    routes,
    routesApi,
    externes,
    generate,
};
